import React from 'react';
import LoanMain from './LoanMain';

const Loan = (props) => {
	return <LoanMain />;
};

export default Loan;
